import { formatDateWithAmPm, getStatusClass } from '../../Style';

export const customHeaders = [
  { field: 'vendor_serial_no', header: 'Vendor ID' },
  //{ field: 'registration_number', header: 'Reg Number' },
  { field: 'agency_name', header: 'Vendor Name' },
  { field: 'email', header: 'Email' },
  { field: 'phone', header: 'Mobile' },
  { field: 'gstin_number', header: 'GSTIN' },
  {
    field: 'last_active',
    header: 'Last Active',
    render: (value) => (value ? formatDateWithAmPm(value) : '-'),
  },
  {
    field: 'created_at',
    header: 'Created Date',
    render: (value) => (value ? formatDateWithAmPm(value) : '-'),
  },
  {
    field: 'status',
    header: 'Vendor Status',
    render: (value) => (
      <span
        className={`badge ${getStatusClass(
          value === 0 ? 'Active' : 'Inactive'
        )}`}
      >
        {value === 0 ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    field: 'approove_status',
    header: 'Approval Status',
    render: (value) => (
      <span
        className={`badge ${getStatusClass(
          value === 1 ? 'Approved' : value === 2 ? 'Pending' : 'Rejected'
        )}`}
      >
        {value === 1 ? 'Approved' : value === 2 ? 'Pending' : 'Rejected'}
      </span>
    ),
  },
];
